import type { SortedInfo } from '~/pages/backoffice/useTableQuery'
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react'
import { Button } from '~/components/ui/button'
import { TableHead } from '~/components/ui/table'
import { cn } from '~/lib/utils'

type IProps = {
  field: string
  label: string
  sortedInfo?: SortedInfo
  onSort: (field: string) => void
  className?: string
}

/**
 * En-tête de colonne triable (RGAA 7.1). La colonne triée et son sens sont
 * exposés (`aria-sort`) et montrés (flèche orientée) : la même icône sur toutes
 * les colonnes ne disait ni laquelle triait, ni dans quel sens.
 */
function SortableTableHead({ field, label, sortedInfo, onSort, className }: IProps) {
  const order = sortedInfo?.field === field ? sortedInfo.order : undefined
  const Icon = order === 'ascend' ? ArrowUp : order === 'descend' ? ArrowDown : ArrowUpDown
  return (
    <TableHead aria-sort={order === 'ascend' ? 'ascending' : order === 'descend' ? 'descending' : 'none'}>
      <Button
        variant="ghost"
        onClick={() => onSort(field)}
        className={cn('h-8 w-full justify-start text-left font-medium', className)}
      >
        {label}
        <Icon className="ml-2 size-4" aria-hidden />
      </Button>
    </TableHead>
  )
}

export default SortableTableHead
